import React from "react";
import { ShieldCheck, Scale, Eye, UserCheck } from "lucide-react";
import { Reveal, SectionHeader } from "./Section";

/**
 * "Pourquoi me faire confiance" — remplace les anciens témoignages
 * (qui étaient fictifs). Quatre piliers de réassurance, posture
 * transparente : cabinet récemment lancé, attention totale au client.
 */
const TRUST_PILLARS = [
  {
    Icon: ShieldCheck,
    title: "Immatriculé et contrôlé",
    body:
      "Courtier immatriculé à l'ORIAS (n° 26008264) et soumis au contrôle de l'ACPR. Vous savez exactement à qui vous confiez vos contrats.",
  },
  {
    Icon: Scale,
    title: "Indépendant, sans conflit d'intérêt",
    body:
      "Je ne suis lié à aucune compagnie. Mon seul objectif est de trouver ce qui vous convient.",
  },
  {
    Icon: Eye,
    title: "Engagement de transparence",
    body:
      "Si vos contrats actuels sont déjà bien placés, je vous le dis. Un bon conseil vaut mieux qu'une vente.",
  },
  {
    Icon: UserCheck,
    title: "Un interlocuteur unique",
    body:
      "Vous n'êtes pas un dossier parmi des milliers. Un seul interlocuteur, joignable, qui s'engage personnellement.",
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="relative py-24 md:py-32 bg-brand-sand">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <SectionHeader
          overline="Pourquoi me faire confiance"
          title="Un cabinet récemment lancé, une attention totale."
        />

        <Reveal>
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            {TRUST_PILLARS.map((p, i) => (
              <div
                key={p.title}
                data-testid={`trust-pillar-${i}`}
                className="bg-white rounded-2xl border border-brand-border p-8 md:p-10 flex gap-5"
              >
                <div className="h-11 w-11 rounded-full bg-brand-ink text-white flex items-center justify-center shrink-0">
                  <p.Icon className="h-4 w-4" />
                </div>
                <div>
                  <h3 className="font-serif text-[22px] leading-tight text-brand-ink">
                    {p.title}
                  </h3>
                  <p className="mt-3 text-brand-ink/70 text-[15px] leading-relaxed">
                    {p.body}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
